/*
 forgotLoginUI

 This class represents the login UI.

 */

import ko from 'knockout';
import { isValidEmailAddress } from '../common';
import { authService } from './authService';

ko.components.register('forgot-login-ui', {
  viewModel: forgotLoginUI,
	template: {
		element: 'forgot-login-ui-template'
	}
});

function forgotLoginUI() {

	var self = this;

	//Public functions
	self.emailAddress = ko.observable("");
	self.sendingUsernameReminder = ko.observable(false);
	self.sendingPasswordReset = ko.observable(false);
	self.showUsernameReminderSentMessage = ko.observable(false);
	self.showPasswordResetSentMessage = ko.observable(false);
	self.showStartingForm = ko.computed(function () {
	  return self.showUsernameReminderSentMessage() === false && self.showPasswordResetSentMessage() === false;
	});
	self.errorMessage = ko.observable("");

	self.emailAddressIsValid = ko.computed(function () {
	  self.errorMessage("");
	  var email = self.emailAddress() || "";
	  return isValidEmailAddress(email);
	});

	self.sendUsernameReminder = function () {

	  self.sendingUsernameReminder(true);
	  self.errorMessage("");

	  authService.sendUsernameReminderEmail(self.emailAddress()).then(
	  	function (response) {

	  	  self.sendingUsernameReminder(false);

	  	  if (response.sentSuccessfully) {
	  	    self.showUsernameReminderSentMessage(true);
	  	    setTimeout(redirectUser, 10000);
	  	  }
	  	  else {
	  	    self.errorMessage(response.errorMessage);
	  	  }
	  	},
	  	function (errorResult) {
	  	  self.sendingUsernameReminder(false);
	  	  self.errorMessage(errorResult);
	  	}
	  )
	}

	self.sendPasswordReset = function () {

	  self.sendingPasswordReset(true);
		self.errorMessage("");

		authService.sendPasswordResetEmail(self.emailAddress()).then(
	  	function (response) {

	  	  self.sendingPasswordReset(false);

	  	  if (response.sentSuccessfully) {
	  	    self.showPasswordResetSentMessage(true);
	  	    setTimeout(redirectUser, 10000);
	  	  }
	  	  else {
	  	    self.errorMessage(response.errorMessage);
	  	  }
	  	},
	  	function (errorResult) {
	  	  self.sendingPasswordReset(false);
	  	  self.errorMessage(errorResult);
	  	}
	  )
	}

	var redirectUser = function () {		
		window.location.href = "login.html";
	}

	var init = function () {
		
	}

	//Init the UI
	init();
}